import { useCallback } from 'react';

import { Apollo } from 'src/gql/generated';

/**
 * Reviewing AI-suggested playbook edits. Both mutations return the whole
 * playbook tree the editor renders (`PlaybookWithSuggestedEdits`), which
 * Apollo normalizes over the detail query's entities, so accepted deletes
 * vanish and accepted moves land without a manual cache write.
 */
export function useResolvePlaybookSuggestedEdit() {
  const [resolve, { loading }] = Apollo.useResolvePlaybookSuggestedEditMutation();
  const resolvePlaybookSuggestedEdit = useCallback(
    (input: Apollo.ResolvePlaybookSuggestedEditInput) => resolve({ variables: { input } }),
    [resolve]
  );

  return { loading, resolvePlaybookSuggestedEdit };
}

export function useResolveAllPlaybookSuggestedEdits() {
  const [resolveAll, { loading }] = Apollo.useResolveAllPlaybookSuggestedEditsMutation();
  const resolveAllPlaybookSuggestedEdits = useCallback(
    (input: Apollo.ResolveAllPlaybookSuggestedEditsInput) => resolveAll({ variables: { input } }),
    [resolveAll]
  );

  return { loading, resolveAllPlaybookSuggestedEdits };
}
